document.addEventListener('DOMContentLoaded', () => {
  // Replace Language of return notification
  // Replace specific <h2> content
  document.querySelectorAll('h2').forEach(h2 => {
    if (h2.textContent.includes("Return in progress")) {
      h2.textContent = "Rücksendung in Bearbeitung";
      
    }
  });

  // Replace specific <p> content
  document.querySelectorAll('p').forEach(p => {
    if (p.textContent.includes("Your return was approved. We emailed you a return shipping label, or you will receive one soon.")) {
      p.textContent = "Deine Rücksendung wurde genehmigt. Wir haben Dir ein Rücksendelabel zugeschickt oder Du wirst bald eines per Email erhalten.";
    }
  });
});
